import { Button, Group, Select } from '@mantine/core';
import { IconFilter, IconPlus } from '@tabler/icons-react';
import { SearchInput } from '../../../components/SearchInput';

interface PracticeFiltersProps {
  searchQuery: string;
  onSearchChange: (value: string) => void;
  status: string | null;
  onStatusChange: (value: string | null) => void;
  onCreatePractice: () => void;
  canCreatePractice?: boolean;
}

export function PracticeFilters({
  searchQuery,
  onSearchChange,
  status,
  onStatusChange,
  onCreatePractice,
  canCreatePractice = false,
}: PracticeFiltersProps): JSX.Element {
  return (
    <Group gap="md" align="center" wrap="nowrap" flex="1">
      <SearchInput
        placeholder="Search practices..."
        value={searchQuery}
        onChange={(e) => onSearchChange(e.target.value)}
        w={280}
      />
      <Select
        placeholder="All Statuses"
        leftSection={<IconFilter size={14} color="var(--mantine-color-gray-5)" />}
        data={[
          { value: '', label: 'All Statuses' },
          { value: 'Active', label: 'Active' },
          { value: 'Inactive', label: 'Inactive' },
        ]}
        value={status}
        onChange={onStatusChange}
      />
      {canCreatePractice && (
      <Button leftSection={<IconPlus size={16} />} onClick={onCreatePractice}>
        Create Practice
      </Button>
      )}
    </Group>
  );
}
